export const CARD_HEIGHT = 220;
export const CARD_HEIGHT_WITH_ACTIONS = 269;
export const CARD_WIDTH_FOR_XXL = 169.33;
export const MIN_CARD_WIDTH = 144;
export const MAX_CARD_WIDTH = 220;
